function LocalStorageSuggestionsCacheManager() { }
LocalStorageSuggestionsCacheManager.prototype.save = function (a, b, c) {
    var d = new Date();
    d.setMilliseconds(c);
    localStorage.setItem(a, '{"expire": "' + d.toJSON() + '", "suggestions" : ' + JSON.stringify(b) + "}");
};
LocalStorageSuggestionsCacheManager.prototype.any = function (a) {
    return !!localStorage.getItem(a);
};
LocalStorageSuggestionsCacheManager.prototype.remove = function (a) {
    localStorage.removeItem(a);
};
LocalStorageSuggestionsCacheManager.prototype.removeAll = function () {
    localStorage.clear();
};
LocalStorageSuggestionsCacheManager.prototype.find = function (a) {
    try {
        var b = localStorage.getItem(a),
            c = JSON.parse(b),
            d = new Date(c.expire);
        new Date().getTime() > d.getTime() && this.remove(a);
        return c.suggestions;
    } catch (e) {
        console.error(e);
    }
    return [];
};
function SearchSuggestion(a) {
    a = "object" === typeof a ? a : {};
    this.id = void 0 !== a.id ? a.id : 0;
    this.name = void 0 !== a.name ? a.name : null;
    this.type = void 0 !== a.type ? a.type : null;
    this.marketId = void 0 !== a.marketId ? a.marketId : 0;
    this.marketName = void 0 !== a.marketName ? a.marketName : null;
    this.latitude = void 0 !== a.latitude ? a.latitude : 0;
    this.longitude = void 0 !== a.longitude ? a.longitude : 0;
    this.city = void 0 !== a.city ? a.city : null;
    this.state = void 0 !== a.state ? a.state : null;
    this.cssClass = void 0 !== a.cssClass ? a.cssClass : null;
    this.icon = void 0 !== a.icon ? a.icon : null;
}
SearchSuggestion.createFromApiData = function (a) {
    var b = new SearchSuggestion();
    b.id = a.Id;
    b.name = a.Name;
    b.type = a.Type;
    b.marketId = a.MarketId;
    b.marketName = a.MarketName;
    b.latitude = a.Latitude;
    b.longitude = a.Longitude;
    b.city = a.City;
    b.state = a.State;
    b.cssClass = 'nhs-c-suggestion';
    return b;
};
function HttpRequest(a) {
    a || (a = {});
    this.url = a.url || "";
    this.method = a.method || "GET";
    this.body = a.body || null;
    this.latest = void 0 !== a.latest ? !!a.latest : !0;
    this.dataHandler = a.dataHandler || this.dataHandler;
    this.responseHandler = a.responseHandler || this.responseHandler;
}
function SearchSuggestion(a) {
    a = "object" === typeof a ? a : {};
    this.id = void 0 !== a.id ? a.id : 0;
    this.name = void 0 !== a.name ? a.name : null;
    this.type = void 0 !== a.type ? a.type : null;
    this.marketId = void 0 !== a.marketId ? a.marketId : 0;
    this.marketName = void 0 !== a.marketName ? a.marketName : null;
    this.latitude = void 0 !== a.latitude ? a.latitude : 0;
    this.longitude = void 0 !== a.longitude ? a.longitude : 0;
    this.city = void 0 !== a.city ? a.city : null;
    this.state = void 0 !== a.state ? a.state : null;
    this.cssClass = void 0 !== a.cssClass ? a.cssClass : null;
    this.dataAttributes = a.dataAttributes ? a.dataAttributes : [];
    this.icon = void 0 !== a.icon ? a.icon : null;
}
SearchSuggestion.createFromApiData = function (a) {
    var b = new SearchSuggestion();
    b.id = a.Id;
    b.name = a.Name;
    b.type = a.Type;
    b.marketId = a.MarketId;
    b.marketName = a.MarketName;
    b.latitude = a.Latitude;
    b.longitude = a.Longitude;
    b.city = a.City;
    b.state = a.State;
    b.cssClass = 'nhs-c-suggestion';
    return b;
};
function SearchSuggestionsCacheManager() {
    LocalStorageSuggestionsCacheManager.call(this);
}
SearchSuggestionsCacheManager.prototype = Object.create(LocalStorageSuggestionsCacheManager.prototype, { constructor: { value: SearchSuggestionsCacheManager } });
SearchSuggestionsCacheManager.prototype.find = function (a) {
    var b = [];
    a = LocalStorageSuggestionsCacheManager.prototype.find.call(this, a);
    for (var c = 0; c < a.length; c++) b.push(new SearchSuggestion(a[c]));
    return b;
};
function AutocompleteSearchHttpRequest() {
    HttpRequest.call(this);
    var a = this.useBaseUrl === true ? document.baseURI : "/";
    -1 === a.indexOf(location.protocol) && (a = a.replace(/https?:/, location.protocol));
    this.baseUrl = a + "gettypeaheadoptions";
}
AutocompleteSearchHttpRequest.prototype = Object.create(HttpRequest.prototype, { constructor: { value: AutocompleteSearchHttpRequest } });
AutocompleteSearchHttpRequest.prototype.dataHandler = function (a) {
  const brandElement = a.form.querySelector('[data-search-box-brand-id]');
  this.url = `${this.baseUrl}?searchTerm=${encodeURI(a.value)}`;

  if (brandElement && brandElement.value !== '0') {
    this.url += `&brandid=${brandElement.value}`;
  }
};
AutocompleteSearchHttpRequest.prototype.responseHandler = function (a) {
    var b = [];
    if (a)
        try {
            for (var c = JSON.parse(a), d = 0; d < c.length; d++) b.push(SearchSuggestion.createFromApiData(c[d]));
        } catch (e) {
            console.warn("Invalid response received: " + a + "\nCaused: " + e);
        }
    return b;
};
function HttpClient(a) {
    this._xhr = new XMLHttpRequest();
    this.httpRequest = a;
}
HttpClient.prototype.send = function (a, b) {
    this.httpRequest.latest && this._xhr.abort();
    this.httpRequest.dataHandler instanceof Function && this.httpRequest.dataHandler(a);
    this._xhr.open(this.httpRequest.method.toUpperCase(), this.httpRequest.url, !0);
    this._xhr.onreadystatechange = function () {
        4 === this._xhr.readyState && b(this.httpRequest.responseHandler instanceof Function ? this.httpRequest.responseHandler(this._xhr.responseText) : this._xhr.responseText);
    }.bind(this);
    this._xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    this._xhr.send("post" === this.httpRequest.method.toLowerCase() ? this.httpRequest.body : null);
};
function SuggestionsEngine(a, b, c) {
    this._suggestionsEngineConfig = a;
    this._httpClient = b;
    this._suggestionsCacheManager = c;
    this._suggestionsEngineConfig.resetCache && this._suggestionsCacheManager.removeAll();
}
SuggestionsEngine.prototype._store = function (a, b) {
    b.length && this._suggestionsEngineConfig.useCache && this._suggestionsCacheManager.save(a, b, this._suggestionsEngineConfig.cacheExpire);
};
SuggestionsEngine.prototype._resolve = function (a, b) {
    var c = this;
    this._httpClient.send(a, function (d) {
        c._store(a, d);
        b instanceof Function && b(d);
    });
};
SuggestionsEngine.prototype.getSuggestions = function (a, b) {
    this._suggestionsEngineConfig.caseSensitive || (a.value = a.value.toLowerCase());
    this._suggestionsEngineConfig.useCache && this._suggestionsCacheManager.any(a.value) ? (b(this._suggestionsCacheManager.find(a.value)), this._suggestionsEngineConfig.staleWhileRevalidate && this._resolve(a)) : this._resolve(a, b);
};
function SearchSuggestionsEngine(a) {
    SuggestionsEngine.call(this, a, new HttpClient(new AutocompleteSearchHttpRequest()), new SearchSuggestionsCacheManager());
}
SearchSuggestionsEngine.prototype = Object.create(SuggestionsEngine.prototype, { constructor: { value: SearchSuggestionsEngine } });
function SuggestionsComponent(a, b) {
    this.targetInput = a;
    this.htmlElement = b;
    this._suggestions = [];
    this._initDomEvents();
    this.onSelect = function () { };
}
SuggestionsComponent.prototype._htmlElementClickHandler = function (a) {
    var b = (a.target.hasAttribute("data-index") ? a.target : a.target.parentElement).getAttribute("data-index");
    a.target.classList.add('nhs-c-suggestion--selected');
    b && ((b = parseInt(b)), this.select(b), this.onSelect(), a.stopImmediatePropagation());

    const form = a.target.closest("form")
    form.dispatchEvent(new Event('submit'));
};
SuggestionsComponent.prototype._targetInputFocusHandler = function () {
    this.targetInput.value && null !== this.getSelectedSuggestion() && this.open();
};
SuggestionsComponent.prototype._keyDownHandler = function (a) {
    if (this.isOpen()) {
        var b = a.key.toLowerCase();
        if (-1 !== b.indexOf("down") || -1 !== b.indexOf("up") || -1 !== b.indexOf("enter") || -1 !== b.indexOf("right")) {
            var c = this.getSelectedSuggestion();
            if (null !== c || !(-1 < b.indexOf("enter") || -1 < b.indexOf("right"))) {
                var d = this._suggestions.indexOf(c);
                -1 < b.indexOf("enter") || -1 < b.indexOf("right")
                    ? (this.select(d), this.onSelect())
                    : null === c && -1 < b.indexOf("down")
                        ? this.select(0, !1)
                        : (-1 < b.indexOf("up") && 0 < d && this.select(d - 1, !1), -1 < b.indexOf("down") && d + 1 < this._suggestions.length && this.select(d + 1, !1), a.preventDefault());
            }
        }
    }
};
SuggestionsComponent.prototype._initDomEvents = function () {
    this.htmlElement.addEventListener("click", this._htmlElementClickHandler.bind(this));
    this.targetInput.addEventListener("focus", this._targetInputFocusHandler.bind(this));
    this.targetInput.addEventListener("keydown", this._keyDownHandler.bind(this));
};
function SearchSuggestionsComponent(a) {
    const form = a.closest('form');
    const list = (form && form.querySelector('[data-typeahead-suggestions]')) || document.createRange().createContextualFragment('<ul class="autocomplete-search-suggestions-container nhs-c-typeahead__list" aria-expanded="false" role="listbox" data-typeahead-suggestions></ul>').querySelector("ul");
    SuggestionsComponent.call(this, a, list); // Call base constructor
}
SearchSuggestionsComponent.prototype = Object.create(SuggestionsComponent.prototype, { constructor: { value: SearchSuggestionsComponent } });
SearchSuggestionsComponent.prototype._clearActiveSuggestion = function () {
    for (var a = 0; a < this.htmlElement.children.length; a++) this.htmlElement.children[a].classList.remove("active", "nhs-c-suggestion--hover", "nhs-c-suggestion--selected");
};

SearchSuggestionsComponent.prototype.add = function (a, b) {
    var c = "";
    c =
        b && b instanceof RegExp
            ? a.name.replace(b, function (a) {
                return "<b>" + a + "</b>";
            })
            : a.name;
    c = document.createRange().createContextualFragment(`<li ${a.dataAttributes.join(" ")} ${a.cssClass ? "class='" + a.cssClass + "'": ""} role="option" data-index="${this._suggestions.length}" id="suggestion${this._suggestions.length + 1}">${a.icon ? a.icon : ''}${c}</li>`).querySelector("li");
    this._suggestions.push(a);
    this.htmlElement.appendChild(c);
};
SearchSuggestionsComponent.prototype.clear = function () {
    this._clearActiveSuggestion();
    this._suggestions = [];
    this.htmlElement.innerHTML = "";
};
SearchSuggestionsComponent.prototype.select = function (a, b) {
    void 0 === b && (b = !0);
    this.targetInput.value = this._suggestions[a].name;
    this.targetInput.setAttribute("data-suggestion-index", a);
    if(b){
        this.close();
    }
    else{
        this._clearActiveSuggestion();
        let element = this.htmlElement.children[a];
        let id = element.id;
        element.classList.add("active", 'nhs-c-suggestion--hover');
        element.setAttribute("aria-selected", "true");
        this._scrollIfNeeded(this.htmlElement.children[a]);
        this.targetInput.setAttribute("aria-activedescendant", id);
    }
    
};
SearchSuggestionsComponent.prototype.getSelectedSuggestion = function () {
    if (this.targetInput.value)
        for (var a = 0; a < this._suggestions.length; a++) {
            var b = this._suggestions[a];
            if ((b.name === this.targetInput.value && this.targetInput.getAttribute("data-suggestion-index") == a) || (this.htmlElement.children[a] && -1 < (this.htmlElement.children[a].getAttribute("class") || "").indexOf("active")))
                return b;
        }
    return null;
};
SearchSuggestionsComponent.prototype._scrollIfNeeded = function (a) {
    a.scrollIntoViewIfNeeded instanceof Function ? a.scrollIntoViewIfNeeded(!1) : a.scrollIntoView({ block: "nearest", inline: "nearest" });
};
SearchSuggestionsComponent.prototype.close = function () {
    this.htmlElement.setAttribute("style", "display:none");
    this.htmlElement.setAttribute('aria-expanded', 'false');
    this.targetInput.setAttribute("aria-activedescendant", '');
    this._clearActiveSuggestion();
};
SearchSuggestionsComponent.prototype.open = function () {
    this.htmlElement.removeAttribute("style");
    this.htmlElement.setAttribute('aria-expanded', 'true');
    this.htmlElement.children[0] && this._scrollIfNeeded(this.htmlElement.children[0]);
};
SearchSuggestionsComponent.prototype.isOpen = function () {
    return !this.htmlElement.hasAttribute("style");
};
function SuggestionsEngineConfig() {
    var a = this;
    this.caseSensitive = !1;
    this.useCache = !0;
    this.resetCache = !1;
    this.cacheExpire = 864e5;
    this._staleWhileRevalidate = !1;
    Object.defineProperty(this, "staleWhileRevalidate", {
        get: function () {
            return a.useCache && a._staleWhileRevalidate;
        },
        set: function (b) {
            a._staleWhileRevalidate = b;
        },
    });
}
function AutocompleteComponent(a, b, c, d) {
    this._observable = b;
    this._searchField = this._observable.field;
    this._engine = c;
    this._suggestionsComponent = d;
    this._context = a;
    this.suggestions = [];
    Object.defineProperty(this, "value", {
        get: function () {
            return this._suggestionsComponent ? this._suggestionsComponent.getSelectedSuggestion() : null;
        }.bind(this),
    });
    this._observable.add(this);
    this._initEvents();
}
AutocompleteComponent.prototype._clickHandler = function (a) {
    a.target === this._context || this._context.contains(a.target) || (this._suggestionsComponent && this._suggestionsComponent.close());
};
AutocompleteComponent.prototype._initEvents = function () {
    document.body.addEventListener("click", this._clickHandler.bind(this));
    document.body.addEventListener("touchstart", this._clickHandler.bind(this), { passive: true });
};
AutocompleteComponent.prototype.update = function (a) {
    this._searchField.value && null === this._suggestionsComponent.getSelectedSuggestion()
        ? this._engine.getSuggestions(
            this._searchField,
            function (b) {
                this.suggestions = b;
                this.displaySuggestions();
                a instanceof Function && a();
            }.bind(this)
        )
        : this._searchField.value || this._suggestionsComponent.close();
};
AutocompleteComponent.prototype.displaySuggestions = function () {
    this._suggestionsComponent.close();
    this._suggestionsComponent.clear();
    if (this.suggestions.length) {
        const highlight = this.includeHighlightInSuggestion ? new RegExp(this._searchField.value.trim(), "i") : '';
        for (var a = highlight, b = 0; b < this.suggestions.length; b++) this._suggestionsComponent.add(this.suggestions[b], a);
        !this._suggestionsComponent.htmlElement.parentElement && this._context.appendChild(this._suggestionsComponent.htmlElement);
        this._suggestionsComponent.open();
    }
};
AutocompleteComponent.prototype.selectSuggestion = function (a) {
    this.hideSuggestions();
    this._searchField.value = this.suggestions[a].name;
};
AutocompleteComponent.prototype.hideSuggestions = function () {
    this._suggestionsComponent && this._suggestionsComponent.close();
};
function SearchFieldObservable(a) {
    this._observers = [];
    this.field = a;
    this._debounceTimer = null;
    this._lastValue = this.field.value;
    this._initDomEvents();
}
SearchFieldObservable.prototype._fieldChangeHandler = function (a) {
    (a.key && ((a = a.key.toLowerCase()), -1 < a.indexOf("down") && -1 < a.indexOf("up") && -1 < a.indexOf("enter") && -1 < a.indexOf("right"))) ||
        (this._lastValue !== this.field.value && ((this._lastValue = this.field.value), this.notify()));
};
SearchFieldObservable.prototype._initDomEvents = function () {
    this.field.addEventListener("change", this._fieldChangeHandler.bind(this));
    this.field.addEventListener("keyup", this._fieldChangeHandler.bind(this));
    this.field.addEventListener("click", this._fieldChangeHandler.bind(this));
    this.field.addEventListener("touchend", this._fieldChangeHandler.bind(this));
    this.field.addEventListener("search", this._fieldChangeHandler.bind(this));
};
SearchFieldObservable.prototype.notify = function () {
    clearTimeout(this._debounceTimer);
    this._debounceTimer = setTimeout(
        function () {
            this.notify();
        }.bind(this),
        50
    );
};
SearchFieldObservable.prototype.add = function (a) {
    this._observers.push(a);
};
SearchFieldObservable.prototype.notify = function () {
    this._observers.forEach(function (a) {
        a.update();
    });
};
function SearchAutocompleteComponent(a) {
    AutocompleteComponent.call(this, a, new SearchFieldObservable(a.querySelector("[data-component-rol=target-input]")));
    this.dependeciesRequested = !1;
    this.includeCurrentLocation = a.hasAttribute("data-component-includeCurrentLocation");
    this.includeCurrentLocationIcon = a.hasAttribute("data-component-include-current-location-icon");
    this.includeHighlightInSuggestion = !a.hasAttribute("data-exclude-highlight");
    Object.defineProperty(this, "isCurrentLocation", {
        get: function () {
            return this._currentLocationSuggestion && this._currentLocationSuggestion === this.value;
        }.bind(this),
    });
    this.onSelect = null;
}
SearchAutocompleteComponent.prototype = Object.create(AutocompleteComponent.prototype, { constructor: { value: SearchAutocompleteComponent } });
SearchAutocompleteComponent.prototype._loadDependencies = function (a) {
    this.dependeciesRequested
        ? this._suggestionsComponent && this._engine && a()
        : ((this._engine = new SearchSuggestionsEngine(new SuggestionsEngineConfig())),
            (this._suggestionsComponent = new SearchSuggestionsComponent(this._searchField)),
            this.includeCurrentLocation && (this._currentLocationSuggestion = new SearchSuggestion({ id: 0, name: "Current Location", cssClass: "currentLocationSuggestion nhs-c-suggestion nhs-c-suggestion--icon",
                icon: this.includeCurrentLocationIcon ? `<div class='nhs-c-suggestion__icon-container'><svg width='14' height='14' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M7.5 0v1.522A5.502 5.502 0 0 1 12.478 6.5H14v1h-1.522A5.502 5.502 0 0 1 7.5 12.478V14h-1v-1.522A5.502 5.502 0 0 1 1.522 7.5H0v-1h1.522A5.502 5.502 0 0 1 6.5 1.522V0h1Zm-5 7a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Zm3 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM7 4.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z' fill='currentColor'/></svg></div>` : null
            })),
            (this._suggestionsComponent.onSelect = this._onSelect.bind(this)),
            a(),
            (this.dependeciesRequested = !0));
};
SearchAutocompleteComponent.prototype._onSelect = function () {
    if (this.onSelect instanceof Function) this.onSelect();
};

/**
 * removeCurrentLocation: removes the current location option from the component and sets the include current location flag to false
 * in order to avoid showing the current location option in further typeahead interactions.
 * @method
 */
SearchAutocompleteComponent.prototype.removeCurrentLocation = function () {
  const currentLocationOption = this._suggestionsComponent.htmlElement.querySelector('[data-current-location]');

  if (!currentLocationOption) {
    return;
  }

  this.includeCurrentLocation = false;
  currentLocationOption.remove();
};

SearchAutocompleteComponent.prototype.update = function (a) {
    this._loadDependencies(
        function () {
            AutocompleteComponent.prototype.update.call(this, a);
        }.bind(this)
    );
};
SearchAutocompleteComponent.prototype.displaySuggestions = function () {
    this.includeCurrentLocation && this.suggestions.unshift(this._currentLocationSuggestion);
    AutocompleteComponent.prototype.displaySuggestions.call(this);
};
SearchAutocompleteComponent.prototype.selectSuggestion = function (a) {
    AutocompleteComponent.prototype.selectSuggestion.call(this, a);
    this._searchField.setAttribute("data-suggestion-index", a);
};
SearchAutocompleteComponent.initAll = function () {
    for (var a = document.querySelectorAll("[data-component=search-autocomplete]"), b = 0; b < a.length; b++) a[b].searchAutocompleteComponent || (a[b].searchAutocompleteComponent = new SearchAutocompleteComponent(a[b]));
};
SearchAutocompleteComponent.initAll();
var SearchFormComponent = function (a) {
    if (!(a && "object" === typeof a && a.form instanceof HTMLFormElement)) throw new TypeError();
    this.form = a.form;
    this.autocomplete = a.autocomplete || this.form.querySelector("[data-component=search-autocomplete]").searchAutocompleteComponent;
    this.searchTextField = a.searchTextField || this.form.querySelector("[name=SearchText]");
    this.pageToHitFields = a.pageToHitFields || this.form.querySelectorAll("[name=pageToHit]");
    this.latitudeField = a.latitudeField || this.form.querySelector("[name=latitude]") || {};
    this.longitudeField = a.longitudeField || this.form.querySelector("[name=longitude]") || {};
    this.locationTypeField = a.locationTypeField || this.form.querySelector("[name=locationType]");
    this.itemIdField = a.itemIdField || this.form.querySelector("[name=itemId]");
    this.marketIdField = a.marketIdField || this.form.querySelector("[name=marketId]");
    this.submitButton = a.submitButton || this.form.querySelector("[type=submit]");
    this.validationError = a.validationError || this.form.querySelector("[data-field-validation-error]")|| this.form.querySelector("#nhs_field_validation_error");
    this.useAutocompleteForSubmit = !!a.useAutocompleteForSubmit || this.form.hasAttribute("data-component-useAutocompleteForSubmit");
    this.shouldAlwaysSubmitForm = a.shouldAlwaysSubmitForm || !1;
    this.useBaseUrl = a.useBaseUrl === undefined ? true : a.useBaseUrl;
    this.submitButton && (this.submitButton.disabled = !1);
    this.clearButton = a.clearButton || this.form.querySelector("[data-clear-button]");
    this.clearButton && this.clearButton.addEventListener("click", this.clearInputElement.bind(this));

    a.submitButton && a.submitButton.addEventListener("click", this._formSubmitHandler.bind(this));
    this.useAutocompleteForSubmit && (this.autocomplete.onSelect = this._formSubmitHandler.bind(this));
    this.form.addEventListener("submit", this._formSubmitHandler.bind(this));
    if(this.searchTextField){
        this.searchTextField.parentElement.addEventListener('focusout', (event) => {
            // close suggestions if the focus is moved to an outside element.
            if (event.relatedTarget && !event.relatedTarget.matches('[data-dont-close-results]') && !event.relatedTarget.matches('[data-typeahead-suggestions]')){
                this.autocomplete.hideSuggestions();
            }

            // Include populated class
            const wrapper = this.searchTextField.closest('[data-typeahead-input-wrapper]');
            const hasValue = !!this.searchTextField.value;
            if (wrapper) {
                if (hasValue) {
                    wrapper.classList.add('nhs-c-typeahead__container--populated');
                } else {
                    wrapper.classList.remove('nhs-c-typeahead__container--populated');
                }
            }
        });
    }
};
SearchFormComponent.prototype._getPageToHit = function () {
    if (1 === this.pageToHitFields.length) return this.pageToHitFields[0].value;
    for (var a = 0; a < this.pageToHitFields.length; a++) if (this.pageToHitFields[a].checked) return this.pageToHitFields[a].value;
    return "";
};
SearchFormComponent.prototype._setPageToHitState = function (a) {
    for (var b = 0; b < this.pageToHitFields.length; b++) this.pageToHitFields[b].disabled = a;
};

/*
* When current location option is selected, this function calculates the url for the search results page to visit,
* and then: redirects the user to that calculated url.
* This algorithm finds out the max latitude/longitude and min latitude/longitude to use in the search results url
* based on the device capabilities like it's height, width and aspect ratio.
*/
SearchFormComponent.prototype._redirectToCurrentLocationSearch = function () {
  const deviceHeight = window.innerHeight;
  const deviceWidth = window.innerWidth;
  /*
   * Convert the device width (in pixels) into the number of tiles.
   * Since there are 256 tiles horizontally at zoom level 9,
   * divide the device width by 256 to get the number of tiles across the width of the map.
   */
  const tilesAcrossWidth = deviceWidth / 256;
  /*
   * Calculate the horizontal span of the map in degrees. At zoom level 9,
   * each tile covers a specific range of longitudes.
   * You can calculate the width of a single tile in degrees by dividing
   * the total longitude range (360 degrees) by the number of tiles (256).
   */
  const degreesPerTile = 360 / 256;
  /*
   * Calculate the maximum and minimum longitude values based on the
   * center point and the number of tiles across the width of the map.
   */
  const maxLongitude = +this.longitudeField.value + (tilesAcrossWidth / 2) * degreesPerTile;
  const minLongitude = +this.longitudeField.value - (tilesAcrossWidth / 2) * degreesPerTile;
  /*
   * The latitude span depends on the aspect ratio of the map.
   * To calculate the maximum and minimum latitude values, you need to know the aspect
   * ratio of your map view (height divided by width). The latitude span is calculated
   * by multiplying the longitude span by the aspect ratio.
   */
  const aspectRatio = deviceHeight / deviceWidth;
  const maxLatitude = +this.latitudeField.value + (tilesAcrossWidth / 2) * degreesPerTile * aspectRatio;
  const minLatitude = +this.latitudeField.value - (tilesAcrossWidth / 2) * degreesPerTile * aspectRatio;
  this.form.querySelector('ul').setAttribute('hidden', '');
  window.location.href = `/communities/map?coordinates=${minLatitude},${minLongitude},${maxLatitude},${maxLongitude}`;
};

SearchFormComponent.prototype._setUpForLocationNameSearch = function () {
    0 !== this.form.action.indexOf("http://") && 0 !== this.form.action.indexOf("https://") && (this.form.action = "/submittypeaheadsearch");
    this.latitudeField.value = "";
    this.longitudeField.value = "";
    this.latitudeField.disabled = !0;
    this.longitudeField.disabled = !0;
    this.searchTextField.disabled = !1;
    this._setPageToHitState(!1);
    this.locationTypeField.value = this.autocomplete.value.type;
    this.itemIdField.value = this.autocomplete.value.id;
    this.marketIdField.value = this.autocomplete.value.marketId;
    this.locationTypeField.disabled = !1;
    this.itemIdField.disabled = !1;
    this.marketIdField.disabled = !1;
};
SearchFormComponent.prototype._getCurrentLocation = function () {
    navigator.geolocation.getCurrentPosition(
        function (a) {
            this.latitudeField.value = a.coords.latitude;
            this.longitudeField.value = a.coords.longitude;
            this._formSubmitHandler();
        }.bind(this),
        function () {
            this._showSearchSubmitError();
        }.bind(this),
        { maximumAge: 0 }
    );
};
SearchFormComponent.prototype._showSearchSubmitError = function () {
  if (this.validationError) {
    this.validationError.style.display = "block";
    this.form.classList.add('nhs-c-typeahead__form--error');
    this.autocomplete.hideSuggestions();
    this.autocomplete.removeCurrentLocation();
  }
};
SearchFormComponent.prototype._clearSearchSubmitError = function () {
    if (this.validationError) {
        this.validationError.style.display = "none";
        this.form.classList.remove('nhs-c-typeahead__form--error');
    }
};
SearchFormComponent.prototype._getRecentSearchValues = function () {
    this.autocomplete.update(
        function () {
            for (var a = -1, b = /,|\./gi, c = 0; c < this.autocomplete.suggestions.length; c++)
                if (this.autocomplete.suggestions[c].name.replace(b, "").toLowerCase() === this.searchTextField.value.replace(b, "").toLowerCase().trim()) {
                    a = c;
                    break;
                }
            -1 < a ? (this.autocomplete.selectSuggestion(a), this._formSubmitHandler()) : this._showSearchSubmitError();
        }.bind(this)
    );
};

/**
   * @private
   * _getParamsEvent: function to get the parameter for events to track in element
   */
SearchFormComponent.prototype._getParamsEvent = function () {
    const params = {};
    const elements = this.form.querySelectorAll('[data-ga4-param]');
    for (let index = 0; index < elements.length; index++) {
        const element = elements[index];
        params[element.dataset.ga4Param] = element.value;
    }
    return params;
};

  /**
   * @private
   * clearInputElement: function to clean the input element
   */
SearchFormComponent.prototype.clearInputElement = function () {
  if (this.searchTextField) {
    this.searchTextField.value = '';
    this.searchTextField.dataset.userText = '';
  }
};

SearchFormComponent.prototype._formSubmitHandler = function (a) {
    a && a.preventDefault();
    const inputText = this.form.querySelector('input[type="search"], [data-input-typeahead]');
    const typeInput = this.form.querySelector('[data-suggestion-type]');
    const idInput = this.form.querySelector('[data-suggestion-id]');
    const suggestionIndex = +inputText.dataset.suggestionIndex;
    const suggestion = this.autocomplete.suggestions[suggestionIndex];

    if (typeInput && suggestion) {
      typeInput.value = suggestion.type;
    }

    if (idInput && suggestion) {
      idInput.value = suggestion.id;
    }

    const infoGa4 = inputText && inputText.closest('[data-ga4-info-event-name]');
    if(infoGa4) {
        const paramsFromInputs = this._getParamsEvent();
        const eventGa4 = {
            eventName: infoGa4.dataset.ga4InfoEventName,
            params: {
                search_value: inputText.value,
                click_target: infoGa4.dataset.ga4InfoEventClick_target
                
            },
            eventType: "GA4Event"
        };
        Object.assign(eventGa4.params, paramsFromInputs);
        document.body.dispatchEvent(new CustomEvent("trackOnDemandEvent", {
            detail: { data: eventGa4 }
        }));
    }
    if (!this.autocomplete.isCurrentLocation && this.shouldAlwaysSubmitForm && this.searchTextField.value) this.form.submit();
    else if (!this.autocomplete.isCurrentLocation || this.latitudeField.value || this.longitudeField.value)
      if (this.autocomplete.isCurrentLocation && this.latitudeField.value && this.longitudeField.value) {
        this._redirectToCurrentLocationSearch();
        return;
      }
      else if (!this.searchTextField.value || !this.autocomplete || (this.autocomplete.dependeciesRequested && null !== this.autocomplete.value))
        if (this.autocomplete && null !== this.autocomplete.value) this._setUpForLocationNameSearch();
        else {
          this._showSearchSubmitError();
          return;
        }
      else {
        this._getRecentSearchValues();
        return;
      }
    else {
      this._getCurrentLocation();
      return;
    }
    this._clearSearchSubmitError();
    const eventSegment = {
      event: this.searchTextField.id === "nhs_GlobalSearchNavLocation" ? 'Header Search Term Selected' : "Search Term Selected",
      input_text: this.searchTextField.dataset.userText,
      search_location: this.searchTextField.value,
      eventType: "segmentEvent"
    };

    document.body.dispatchEvent(new CustomEvent("trackOnDemandEvent", {
      detail: { data: eventSegment }
    }));
    this.form.submit();
};
